import type { ThemeOptions } from '@mui/material';

export const themeCommon: ThemeOptions = {
  typography: {
    subtitle1: {
      fontSize: '1rem',
      fontWeight: '500',
    },
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '1.55rem',
      fontWeight: 700,
    },
    h3: {
      fontSize: '1.2rem',
      fontWeight: 700,
    },
    h4: {
      fontSize: '1.1rem',
      fontWeight: 700,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 700,
    },
    h6: {
      fontSize: '0.9rem',
      fontWeight: 700,
    },
    button: {
      textTransform: 'unset',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  mixins: {
    toolbar: {
      height: 60,
    },
  },
  shape: {
    borderRadius: 8,
  },
};
